module.exports = __webpack_public_path__ + "img/04.443a98bb.jpg";